import { ServiceMode, ServicePartyDragMode } from 'state/service/ui';

export function setServiceMode(mode: ServiceMode): BaseTockAction {
  return {
    type: 'SERVICE_SET_MODE',
    payload: mode,
  };
}

export function resetServiceMode(): BaseTockAction {
  return {
    type: 'SERVICE_SET_MODE',
    payload: 'DEFAULT',
  };
}

export function setServicePartyDragMode(mode: ServicePartyDragMode): BaseTockAction {
  return {
    type: 'SERVICE_SET_DRAG_MODE',
    payload: mode,
  };
}

export function setSeatedWalkInPartyId(walkInPartyId?: number): BaseTockAction {
  return {
    type: 'SET_SEATED_WALKIN_ID',
    payload: walkInPartyId,
  };
}
